import { VuetifyThemeVariant } from 'vuetify/types/services/theme';

import { lightTheme } from '@cnamts/design-tokens/dist/colors';
const currentTheme = lightTheme as VuetifyThemeVariant;

import { AmeliproColors } from './ameliproColors/ameliproColors';
const ameliproColors = AmeliproColors;

import { default as vuetifyColors } from 'vuetify/es5/util/colors';
const colors = vuetifyColors as unknown as Record<string, Record<string, string>>;

export function classToHex(
	color: string
): string {
	let [colorName, colorModifier] = color
		.toString()
		.trim()
		.split(' ', 2) as (string | undefined)[];

	colorName = colorName?.replace(/-./, x => x[1].toUpperCase());
	colorModifier = colorModifier?.replace('-', '');
	let fullColorName = '';

	let hexColor = '';
	if (colorName && colorName in colors) {
		if (colorModifier && colorModifier in colors[colorName]) {
			hexColor = colors[colorName][colorModifier];
		} else if ('base' in colors[colorName]) {
			hexColor = colors[colorName].base;
		}
	} else if (colorName && colorName in currentTheme) {
		hexColor = currentTheme[colorName] as string;
	} else if (color && colorName) {
		if(colorModifier === undefined) {
			fullColorName = colorName;
		} else {
			fullColorName = colorName + colorModifier;
		}
		hexColor = ameliproColors[fullColorName]?.hexColor;
	}

	return hexColor;
}
